// extracted by mini-css-extract-plugin
module.exports = {"main":"ToggleMobileMenu_main__F4tRP","search-fade-in":"ToggleMobileMenu_search-fade-in__WP06v"};